import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { GeneralService } from 'src/app/services/general.service';
import { IGetPermissionMandatoryField } from '../interface';
import { ECallScriptForms, EUserFunctions } from '../enum';

@Component({
    selector: 'app-followup-shared',
    templateUrl: 'followup-shared.component.html',
    styleUrls: ['followup-shared.component.scss'],
    standalone: false
})
export class FollowupSharedComponent implements OnInit {
    @Input() callScriptFields;
    @Input() section;
    @Output() emitFollowupSaveCallScript = new EventEmitter();
    @Output() emitChangedScript = new EventEmitter();

    componentName = 'followup-shared.component.html';
    formName = 'followUpForm';
    formId = 130;
    RequiredList = [];
    followUpForm: FormGroup;
    editRight: boolean;
    viewRightFalseMessage: string;
    editRightFalseMessage: string;
    @Input() assignedToList: any;
    @Input() followUpActionList: any;
    @Input() priorityList: any;
    @Input() AssignedTo;
    @Input() FollowUpDate;
    @Input() priority;
    @Input() follwupNotes;
    @Input() confirmNumber: number;
    @Input() tenantId: number;
    @Input() facilityId: number;
    @Input() followUpNotesList;
    @Output() emitFollowupSave = new EventEmitter();
    @Output() emitFollowupCancel = new EventEmitter();
    @ViewChild('tooltip', { static: false }) public tooltip: TooltipComponent;
    contactInfo: any;
    // map the groupBy field with Category column
    public groupFields: Object = { groupBy: 'Category', text: 'Name', value: 'Id' };
    // set the height of the popup element
    public height = '200px';
    // set the placeholder to DropDownList input element
    public groupWaterMark = 'Select';
    public customAttri: object;

    constructor(private formBuilder: FormBuilder,
        private generalService: GeneralService,
        private facOpsDataService: FacOpsDataService) { }

    ngOnInit(): void {
        this.customAttri = { 'class': 'customcss' };
        this.followUpForm = this.formBuilder.group({
            AssignedTo: [''],
            Priority: [''],
            FollowUpAction: [''],
            FollowUpDate: [''],
            Notes: [''],
        });
        this.setUserPermissions();
        this.setMandatoryField();

        this.facOpsDataService.scriptIndex$.subscribe(({ section, index }) => {
            if (section !== this.section || this.facOpsDataService.onPageOpen) {
                return;
            }
            this.onScriptChange();
        });
    }

    get getContactInfoService() {
        return this.facOpsDataService.contactInfo;
    }
    openCancel() {
        this.emitFollowupCancel.emit(this.followUpForm.dirty);
    }

    saveFollowups() {
        this.followUpForm.markAsUntouched();
        this.emitFollowupSave.emit(this.followUpForm.value);
    }

    mouseover(args) {
        if (args.target.classList.contains('customcss') && args.target.innerText) {
            this.tooltip.content = args.target.innerText;
        }
    }

    setUserPermissions() {
        this.editRight = this.generalService.getUserPermissionsForModule(EUserFunctions['Follow-Ups']).EditRight;
        this.editRightFalseMessage = this.generalService.EditRightFalseMessage;
        this.viewRightFalseMessage = this.generalService.ViewRightFalseMessage;
    }

    setMandatoryField() {
        this.generalService.GetMandatoryFields(this.facilityId, this.componentName, this.formName)
            .subscribe((response: IGetPermissionMandatoryField) => {
                const data = response;
                if (data.Form.ListOfProperties.length !== 0) {
                    this.RequiredList = data.Form.ListOfProperties;
                    data.Form.ListOfProperties.forEach(field => {
                        if (field.Required) {
                            if (field.Name === 'Notes') {
                                this.followUpForm.get(field.Name).setValidators([Validators.required, this.generalService.noWhitespaceValidator]);
                            } else {
                                this.followUpForm.get(field.Name).setValidators([Validators.required]);
                            }
                        } else {
                            this.followUpForm.get(field.Name).setValidators(null);
                        }
                        this.followUpForm.updateValueAndValidity();
                    });
                }
                this.followUpForm.patchValue({
                    AssignedTo: this.AssignedTo == null ? this.assignedToList[0].Id : this.AssignedTo.Id,
                    FollowUpDate: this.FollowUpDate,
                    FollowUpAction: this.followUpActionList[0].Id,
                    Priority: this.priority === 0 ? this.priorityList[0].Id : this.priority,
                    Notes: this.follwupNotes
                });
            });
    }

    onScriptChange() {
        let script = this.facOpsDataService.getScript(this.section);
        if (!script || !script.FormId || script.FormId == ECallScriptForms['Prospect/Reservation/Rental: Add Follow Up']
            || (script.firstTimeCalled && !script.buttonNavigate)) {
            return;
        }
        script.firstTimeCalled = true;
        if (this.followUpForm.valid) {
            this.emitFollowupSaveCallScript.emit(this.followUpForm.value);
        }
        this.emitChangedScript.emit(script);
    }
}
